<template>
  <div class="tournament-page">
    <MainNavbar />

    <main class="content">
      <TournamentHero />
      <TournamentFeatures />
      <TournamentMobilePayments />
      <TournamentUseCases />
      <TournamentHowItWorks />
      <TournamentServicesAndSports />
    </main>

    <MainFooter />
  </div>
</template>

<script setup>
import MainNavbar from "@/components/main/headernfooter/header.vue";
import MainFooter from "@/components/main/headernfooter/Footer.vue";

import TournamentHero from "@/components/tournament/TournamentHero.vue";
import TournamentFeatures from "@/components/tournament/TournamentFeatures.vue";
import TournamentMobilePayments from "@/components/tournament/TournamentMobilePayments.vue";
import TournamentUseCases from "@/components/tournament/TournamentUseCases.vue";
import TournamentHowItWorks from "@/components/tournament/TournamentHowItWorks.vue";
import TournamentServicesAndSports from "@/components/tournament/TournamentServicesAndSports.vue";
</script>

<style scoped>
.tournament-page {
  min-height: 100vh;
  background: var(--background-color2);
  color: var(--text-color1);
  font-family: "Poppins", sans-serif;
}

.content {
  width: min(96vw, 1600px);
  margin: 0 auto;
  padding: clamp(70px, 8vw, 90px) clamp(1rem, 2.4vw, 2.5rem) 2.8rem;
  background: linear-gradient(180deg, var(--background-color2) 0%, rgba(0, 0, 0, 0.02) 100%);
  border-top: 1px solid var(--border-color-hover1, #e5e7eb);
  border-left: 1px solid var(--border-color-hover1, #e5e7eb);
  border-right: 1px solid var(--border-color-hover1, #e5e7eb);
  border-radius: 0 0 18px 18px;
}

@media (min-width: 768px) {
  .content {
    width: min(95vw, 1680px);
    padding: clamp(70px, 8vw, 90px) clamp(1.4rem, 2.8vw, 3rem) 3.25rem;
  }
}

@media (min-width: 1280px) {
  .content {
    width: min(94vw, 1720px);
  }
}
</style>
